import { apiService } from "./api";

export const guestSubmissionService = {
  // Create guest submission
  createGuestSubmission: async (token, submissionData) => {
    return await apiService.post(`/guest/submit/${token}`, submissionData);
  },

  // Upload video file for guest (using apiService.upload for multipart)
  uploadGuestVideo: async (videoFile, onProgress) => {
    const formData = new FormData();
    formData.append("video", videoFile);

    return await apiService.upload(`/guest/upload/video`, formData, {
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });
  },
  // Get all guest submissions
  getGuestSubmissions: async (
    page = 1,
    limit = 10,
    search = "",
    status = ""
  ) => {
    const params = { page, limit };
    if (search) params.search = search;
    if (status) params.status = status;

    return await apiService.get("/guest-submissions", { params });
  },

  // Update guest submission status
  updateGuestSubmissionStatus: async (id, status, reviewNotes = "") => {
    return await apiService.patch(`/guest-submissions/${id}/status`, {
      status,
      reviewNotes,
    });
  },

  // Get guest submission by ID
  getGuestSubmissionById: async (id) => {
    return await apiService.get(`/guest-submissions/${id}`);
  },

  // Upload video file
  uploadVideo: async (formData) => {
    return await apiService.post("/upload-video", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default guestSubmissionService;
